export default {
      id: "menu-usage",
      viewBox: "0 0 23 20",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#menu",
      toString: function () {
        return this.url;
      }
    }